import { GzAntimalwareAntiExploitWebComponent } from './component/GzAntimalwareAntiExploitWebComponent';

export { GzAntimalwareAntiExploitWebComponent };
